import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { Exercise } from '../models/exercise';
import { AppSettings } from '../providers/app-settings';

@Injectable()
export class ExerciseService {

  private exerciseApiUrl: string;

  constructor(public http: Http, private appSettings: AppSettings) {
    this.exerciseApiUrl = this.appSettings.DB_API_ENDPOINT + 'exercises/';
  }

  private getDataInJson(res: Response) {
    return res.json();
  }

  public getAllExercises(): Promise<Array<Exercise>> {
    return  this.http.get(this.exerciseApiUrl, this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public addExercise(editExercise): Observable<any> {
    return this.http.post(this.exerciseApiUrl, editExercise, this.appSettings.apiOptions)
     .map(this.getDataInJson);
  }

  public delExercise(id): Observable<any> {
    return this.http.delete(this.exerciseApiUrl + id, this.appSettings.apiOptions);
  }

  public editExercise(editExercise): Observable<any> {
    return  this.http.put(this.exerciseApiUrl + editExercise._id, editExercise, this.appSettings.apiOptions);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/exercise.service.ts